export const LAST_MONTH = "lastmonth";
export const CURRENT_MONTH = "currentmonth";
export const LAST_3_MONTHS = "last3months";
export const LAST_6_MONTHS = "last6months";
export const LAST_12_MONTHS = "last12months";
export const CURRENT_YEAR = "currentYear";
export const CURRENT_TAX_YEAR = "currentTaxYear";
export const LAST_TAX_YEAR = "lastTaxYear";
export const LAST_YEAR = "lastYear";
export const LAST_30_DAYS = "last30days";
export const LAST_90_DAYS = "last90days";
export const LAST_180_DAYS = "last180days";
export const CUSTOM = "custom";
export const CURRENT_WEEK = "currentweek";
export const NEXT_WEEK = "nextweek";
export const NEXT_MONTH = "nextmonth";
export const CURRENT_QUARTER = "currentquarter";
export const LAST_QUARTER = "lastquarter";
export const NEXT_QUARTER = "nextquarter";
